class OrdersController {
    static $inject = ["$q", "$location", "stToast", "tpsrService", "reportService"];

    constructor($q, $location, stToast, tpsrService, reportService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.reportService = reportService;

        this.user = null;
        this.orders = [];
        this.paging = {
            size: 100,
            number: 1,
            totalQty: 0,
            orderBy: "create_date",
            orderDescending: true
        };
        this.isAdmin = false;
    }

    $onInit() {
        
        
        let user_id = this.tpsr.user.user_id;
        if (this.forUserId)
            if (this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin || this.tpsr.user.is_manager || this.tpsr.is_approver)
                user_id = this.forUserId;

        return this.$q.all([
            this._loadUser(user_id),
            this._loadOrders(user_id)
        ]);
    }

    prevPageClicked = () => {
        this.paging.number--;
        return this._loadOrders(this.user.user_id);
    };

    nextPageClicked = () => {
        this.paging.number++;
        return this._loadOrders(this.user.user_id);
    };

    createOrderClicked = () => {
        if(this.tpsr.user.user_id !== this.user.user_id)
            this.$location.url(`/users/${this.user.user_id}/orders/create`);
        else
            this.$location.url(`/orders/create`);
    };

    detailsClicked = order => {
        this.$location.url(`/orders/${order.order_id}`);
    };

    approveClicked = order => {
        return this.tpsr.approveOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Approved", `Order approved.`)
                this._loadOrders(this.user.user_id);
            }
        });
    };

    rejectClicked = order => {
        return this.tpsr.rejectOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Rejected", `Order rejected.`)
                this._loadOrders(this.user.user_id);
            }
        });
    };

    showApproveReject = order => {
        if (!this.tpsr.user.is_approver)
            return false;

        if (!(order.order_status === 'PND' || order.order_status === 'REJ'))
            return false;

        if (this.tpsr.user.user_id === order.create_user)
            return false;

        return true;
    };

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id).then(result => this.user = result);
    };

    _loadOrders = user_id => {
        return this.tpsr.getOrdersUser(this.paging.size, this.paging.number, this.paging.orderBy, this.paging.orderDescending, user_id)
            .then(result => {
                this.orders = result.orders;
                this.paging.totalQty = result.totalQty;
            });
    };
}

angular
    .module("app")
    .component("orders", { // orders
        bindings: {
            forUserId: "<"
        },
        templateUrl: "src/app/orders/orders.html",
        controller: OrdersController
    });
